<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原代码 + 折叠搜索栏） ====================== -->
    <div class="pc-version">
      <div
        class="user-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（PC 折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 折叠时只显示前2个搜索项 + 搜索/重置按钮 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>
            <el-input
              v-model="searchParams.mobile"
              placeholder="请输入手机号"
              clearable
              style="width: 220px"
            ></el-input>
            <el-input
              v-model="searchParams.nickname"
              placeholder="请输入昵称"
              clearable
              style="width: 220px"
            ></el-input>
            <el-input
              v-model="searchParams.user_no"
              placeholder="请输入用户编号"
              clearable
              style="width: 220px"
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="请选择状态"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in statusList"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchParams.level_id"
              placeholder="请选择会员等级"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in levelList"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchParams.is_anchor"
              placeholder="是否主播"
              clearable
              style="width: 150px"
            >
              <el-option label="是主播" :value="1"></el-option>
              <el-option label="非主播" :value="0"></el-option>
            </el-select>
          </div>

          <!-- 搜索/重置/列筛选 始终显示 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getUserList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="用户ID"
            prop="id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            width="180"
            align="center"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.avatar"
                style="
                  width: 50px;
                  height: 50px;
                  object-fit: cover;
                  border-radius: 4px;
                "
                alt="头像"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="昵称"
            prop="nickname"
            min-width="150"
            v-if="checkedColumns.includes('nickname')"
          />
          <el-table-column
            label="手机号"
            prop="mobile"
            width="150"
            align="center"
            v-if="checkedColumns.includes('mobile')"
          />
          <el-table-column
            label="真实姓名"
            prop="real_name"
            width="120"
            align="center"
            v-if="checkedColumns.includes('real_name')"
          />
          <el-table-column
            label="会员等级"
            prop="level_name"
            width="120"
            align="center"
            v-if="checkedColumns.includes('level_name')"
          />
          <el-table-column
            label="父级ID"
            prop="parent_id"
            width="120"
            align="center"
            v-if="checkedColumns.includes('parent_id')"
          />
          <el-table-column
            label="是否主播"
            width="100"
            align="center"
            v-if="checkedColumns.includes('is_anchor')"
          >
            <template slot-scope="scope">
              <span
                :class="scope.row.is_anchor == 1 ? 'color-green' : 'color-gray'"
                >{{ scope.row.is_anchor == 1 ? "是" : "否" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="金币余额"
            prop="balance"
            width="120"
            align="center"
            v-if="checkedColumns.includes('balance')"
          />
          <el-table-column
            label="钻石"
            prop="point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('point')"
          />
          <el-table-column
            label="能量"
            prop="energy"
            width="100"
            align="center"
            v-if="checkedColumns.includes('energy')"
          />
          <el-table-column
            label="总流水"
            prop="total_pay"
            width="120"
            align="center"
            v-if="checkedColumns.includes('total_pay')"
          />
          <el-table-column
            label="总充值"
            prop="total_recharge"
            width="120"
            align="center"
            v-if="checkedColumns.includes('total_recharge')"
          />
          <el-table-column
            label="账号状态"
            width="130"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.status == 1
                    ? 'color-green'
                    : scope.row.status == 0
                    ? 'color-red'
                    : 'color-gray'
                "
              >
                {{
                  scope.row.status == 1
                    ? "正常"
                    : scope.row.status == 0
                    ? "封禁"
                    : "注销"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="操作"
            width="220"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                style="color: #409eff; margin-right: 10px"
                @click.stop="openEditDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-plus"
                style="color: #409eff; margin-right: 10px"
                @click.stop="openRechargeDialog(scope.row)"
                >充值</el-button
              >
              <el-button
                type="text"
                icon="el-icon-minus"
                style="color: #409eff"
                @click.stop="openDeductDialog(scope.row)"
                >扣除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="用户详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="用户ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户编号"
              ><span>{{ detailForm.user_no }}</span></el-form-item
            >
            <el-form-item label="头像"
              ><img
                :src="detailForm.avatar"
                style="width: 60px; height: 60px; object-fit: cover"
            /></el-form-item>
            <el-form-item label="昵称"
              ><span>{{ detailForm.nickname }}</span></el-form-item
            >
            <el-form-item label="手机号"
              ><span>{{ detailForm.mobile }}</span></el-form-item
            >
            <el-form-item label="真实姓名"
              ><span>{{ detailForm.real_name || "未填写" }}</span></el-form-item
            >
            <!-- <el-form-item label="身份证号"
              ><span>{{ detailForm.id_card || "未填写" }}</span></el-form-item
            > -->
            <el-form-item label="登录IP"
              ><span>{{ detailForm.ip || "-" }}</span></el-form-item
            >
            <el-form-item label="会员等级"
              ><span>{{ detailForm.level_name }}</span></el-form-item
            >
            <el-form-item label="父级ID"
              ><span>{{ detailForm.parent_id || 0 }}</span></el-form-item
            >
            <el-form-item label="是否主播">
              <span
                :class="
                  detailForm.is_anchor == 1 ? 'color-green' : 'color-gray'
                "
                >{{ detailForm.is_anchor == 1 ? "是主播" : "非主播" }}</span
              >
            </el-form-item>
            <el-form-item label="金币余额"
              ><span>{{ detailForm.balance }} 元</span></el-form-item
            >
            <el-form-item label="钻石"
              ><span>{{ detailForm.point }}</span></el-form-item
            >
            <el-form-item label="能量"
              ><span>{{ detailForm.energy }}</span></el-form-item
            >
            <el-form-item label="总流水"
              ><span>{{ detailForm.total_pay }} 元</span></el-form-item
            >
            <el-form-item label="总充值金额"
              ><span>{{ detailForm.total_recharge }} 元</span></el-form-item
            >
            <el-form-item label="账号状态">
              <span
                :class="
                  detailForm.status == 1
                    ? 'color-green'
                    : detailForm.status == 0
                    ? 'color-red'
                    : 'color-gray'
                "
              >
                {{
                  detailForm.status == 1
                    ? "正常"
                    : detailForm.status == 0
                    ? "封禁"
                    : "注销"
                }}
              </span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- PC 编辑弹窗 -->
        <el-dialog
          title="编辑用户信息"
          :visible.sync="editDialogVisible"
          width="500px"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 20px">
            <img
              :src="editForm.avatar"
              style="
                width: 70px;
                height: 70px;
                border-radius: 6px;
                cursor: pointer;
              "
              @click="openImageLibrary"
            />
            <div style="margin-top: 8px; font-size: 16px; font-weight: bold">
              {{ editForm.nickname }}
            </div>
            <div style="color: #999; margin-top: 4px">
              用户编号：{{ editForm.user_no }}
            </div>
            <div style="color: #409eff; margin-top: 4px; font-size: 12px">
              点击头像可更换
            </div>
          </div>
          <el-form :model="editForm" label-width="100px" ref="editRef">
            <el-form-item label="用户ID"
              ><el-input v-model="editForm.id" disabled
            /></el-form-item>
            <el-form-item label="昵称" prop="nickname"
              ><el-input v-model="editForm.nickname" placeholder="请输入昵称"
            /></el-form-item>
            <el-form-item label="账号状态" prop="status">
              <el-select v-model="editForm.status" placeholder="请选择状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.status"
                  :label="item.desc"
                  :value="item.status"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否主播" prop="is_anchor">
              <el-select v-model="editForm.is_anchor" placeholder="请选择">
                <el-option label="是主播" :value="1" />
                <el-option label="非主播" :value="0" />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="editDialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="submitLoading"
              @click="submitEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 头像库 -->
        <el-dialog
          title="选择头像"
          :visible.sync="imageDialogVisible"
          width="700px"
          append-to-body
        >
          <div v-loading="imgLoading" class="image-grid">
            <div
              v-for="img in imageList"
              :key="img.id"
              class="img-item"
              @click="selectImage(img)"
            >
              <img :src="img.url" alt="预览" />
            </div>
          </div>
          <el-pagination
            @current-change="getImageList"
            :current-page="imgPage.page"
            :page-size="imgPage.page_size"
            layout="prev, pager, next"
            :total="imgTotal"
            style="text-align: center; margin-top: 10px"
          ></el-pagination>
        </el-dialog>

        <!-- PC 充值弹窗 -->
        <el-dialog
          title="用户充值"
          :visible.sync="rechargeDialogVisible"
          width="500px"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 20px">
            <img
              :src="rechargeForm.avatar"
              style="width: 70px; height: 70px; border-radius: 6px"
            />
            <div style="margin-top: 8px; font-size: 16px; font-weight: bold">
              {{ rechargeForm.nickname }}
            </div>
            <div style="color: #999; margin-top: 4px">
              用户编号：{{ rechargeForm.user_no }}
            </div>
          </div>
          <el-form :model="rechargeForm" label-width="100px" ref="rechargeRef">
            <el-form-item label="用户ID"
              ><el-input v-model="rechargeForm.user_id" disabled
            /></el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="rechargeForm.type"
                placeholder="请选择类型"
                @change="onRechargeTypeChange"
              >
                <el-option
                  v-for="item in rechargeTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数量" prop="num"
              ><el-input
                v-model.number="rechargeForm.num"
                type="number"
                placeholder="请输入数量"
            /></el-form-item>
            <el-form-item label="选择优惠券" v-if="rechargeForm.type == 7">
              <el-select
                v-model="rechargeForm.coupon_id"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="rechargeDialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="submitLoading"
              @click="submitRecharge"
              >确认充值</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 扣除弹窗 -->
        <el-dialog
          title="用户扣除"
          :visible.sync="deductDialogVisible"
          width="500px"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 20px">
            <img
              :src="deductForm.avatar"
              style="width: 70px; height: 70px; border-radius: 6px"
            />
            <div style="margin-top: 8px; font-size: 16px; font-weight: bold">
              {{ deductForm.nickname }}
            </div>
            <div style="color: #999; margin-top: 4px">
              用户编号：{{ deductForm.user_no }}
            </div>
          </div>
          <el-form :model="deductForm" label-width="100px" ref="deductRef">
            <el-form-item label="用户ID"
              ><el-input v-model="deductForm.user_id" disabled
            /></el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="deductForm.type"
                placeholder="请选择类型"
                @change="onDeductTypeChange"
              >
                <el-option
                  v-for="item in deductTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数量" prop="num"
              ><el-input
                v-model.number="deductForm.num"
                type="number"
                placeholder="请输入数量"
            /></el-form-item>
            <el-form-item label="选择优惠券" v-if="deductForm.type == 11">
              <el-select
                v-model="deductForm.coupon_id"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="deductDialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="submitLoading"
              @click="submitDeduct"
              >确认扣除</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（折叠搜索栏） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-user-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索（折叠版） -->
        <div class="mobile-search-group">
          <!-- 折叠/展开按钮 -->
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>

          <!-- 折叠时隐藏所有搜索项 -->
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
              prefix-icon="el-icon-search"
            />
            <el-input
              v-model="searchParams.mobile"
              placeholder="手机号"
              clearable
              size="medium"
            />
            <el-input
              v-model="searchParams.nickname"
              placeholder="昵称"
              clearable
              size="medium"
            />
            <el-input
              v-model="searchParams.user_no"
              placeholder="用户编号"
              clearable
              size="medium"
            />
            <el-select
              v-model="searchParams.status"
              placeholder="状态"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in statusList"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              />
            </el-select>
            <el-select
              v-model="searchParams.level_id"
              placeholder="会员等级"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in levelList"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>
            <el-select
              v-model="searchParams.is_anchor"
              placeholder="是否主播"
              clearable
              size="medium"
            >
              <el-option label="是主播" :value="1" />
              <el-option label="非主播" :value="0" />
            </el-select>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getUserList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-header">
              <img :src="item.avatar" class="avatar" />
              <div class="info">
                <div class="nickname">{{ item.nickname }}</div>
                <div class="uid">ID: {{ item.id }} · {{ item.user_no }}</div>
              </div>
              <div
                class="status"
                :class="
                  item.status == 1 ? 'ok' : item.status == 0 ? 'ban' : 'del'
                "
              >
                {{
                  item.status == 1 ? "正常" : item.status == 0 ? "封禁" : "注销"
                }}
              </div>
            </div>
            <div class="card-body">
              <div>手机: {{ item.mobile || "-" }}</div>
              <div>等级: {{ item.level_name }}</div>
              <div>父ID: {{ item.parent_id || 0 }}</div>
              <div>主播: {{ item.is_anchor == 1 ? "是" : "否" }}</div>
              <div>金币: {{ item.balance }} 元</div>
              <div>钻石: {{ item.point }} · 能量: {{ item.energy }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openEditDialogMobile(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="success"
                round
                @click.stop="openRechargeDialogMobile(item)"
                >充值</el-button
              >
              <el-button
                size="mini"
                type="warning"
                round
                @click.stop="openDeductDialogMobile(item)"
                >扣除</el-button
              >
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- ====================== 移动端 独立弹窗 ====================== -->
        <!-- 移动端详情 -->
        <el-dialog
          title="用户详情"
          :visible.sync="detailVisibleMobile"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="90px" size="small">
            <el-form-item label="用户ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="昵称"
              ><span>{{ detailForm.nickname }}</span></el-form-item
            >
            <el-form-item label="手机"
              ><span>{{ detailForm.mobile }}</span></el-form-item
            >
            <el-form-item label="等级"
              ><span>{{ detailForm.level_name }}</span></el-form-item
            >
            <el-form-item label="父ID"
              ><span>{{ detailForm.parent_id || 0 }}</span></el-form-item
            >
            <el-form-item label="金币"
              ><span>{{ detailForm.balance }} 元</span></el-form-item
            >
            <el-form-item label="状态">
              <span
                :class="
                  detailForm.status == 1
                    ? 'color-green'
                    : detailForm.status == 0
                    ? 'color-red'
                    : 'color-gray'
                "
              >
                {{
                  detailForm.status == 1
                    ? "正常"
                    : detailForm.status == 0
                    ? "封禁"
                    : "注销"
                }}
              </span>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端编辑 -->
        <el-dialog
          title="编辑用户"
          :visible.sync="editDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 15px">
            <img
              :src="editForm.avatar"
              style="width: 60px; height: 60px; border-radius: 6px"
              @click="openImageLibraryMobile"
            />
            <div>点击头像更换</div>
          </div>
          <el-form :model="editForm" label-width="80px">
            <el-form-item label="昵称"
              ><el-input v-model="editForm.nickname" size="medium"
            /></el-form-item>
            <el-form-item label="状态">
              <el-select v-model="editForm.status" size="medium">
                <el-option
                  v-for="item in statusList"
                  :key="item.status"
                  :label="item.desc"
                  :value="item.status"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="主播">
              <el-select v-model="editForm.is_anchor" size="medium">
                <el-option label="是主播" :value="1" />
                <el-option label="非主播" :value="0" />
              </el-select>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              gap: 10px;
              display: flex;
              justify-content: flex-end;
            "
          >
            <el-button size="medium" @click="editDialogVisibleMobile = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :loading="submitLoading"
              @click="submitEditMobile"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端头像库 -->
        <el-dialog
          title="选择头像"
          :visible.sync="imageDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imgLoading"
            style="display: flex; flex-wrap: wrap; gap: 8px; padding: 10px"
          >
            <div
              v-for="img in imageList"
              :key="img.id"
              style="width: 60px; height: 60px"
              @click="selectImageMobile(img)"
            >
              <img
                :src="img.url"
                style="
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 4px;
                "
              />
            </div>
          </div>
        </el-dialog>

        <!-- 移动端充值 -->
        <el-dialog
          title="用户充值"
          :visible.sync="rechargeDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 20px">
            <img
              :src="rechargeForm.avatar"
              style="width: 70px; height: 70px; border-radius: 6px"
            />
            <div style="margin-top: 8px; font-size: 16px; font-weight: bold">
              {{ rechargeForm.nickname }}
            </div>
            <div style="color: #999; margin-top: 4px">
              用户编号：{{ rechargeForm.user_no }}
            </div>
          </div>
          <el-form :model="rechargeForm" label-width="80px" size="medium">
            <el-form-item label="类型">
              <el-select v-model="rechargeForm.type" size="medium">
                <el-option
                  v-for="item in rechargeTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数量"
              ><el-input
                v-model.number="rechargeForm.num"
                type="number"
                size="medium"
                placeholder="数量"
            /></el-form-item>
            <el-form-item label="优惠券" v-if="rechargeForm.type == 7">
              <el-select
                v-model="rechargeForm.coupon_id"
                size="medium"
                clearable
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              gap: 10px;
              display: flex;
              justify-content: flex-end;
            "
          >
            <el-button
              size="medium"
              @click="rechargeDialogVisibleMobile = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :loading="submitLoading"
              @click="submitRechargeMobile"
              >确认</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端扣除 -->
        <el-dialog
          title="用户扣除"
          :visible.sync="deductDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div style="text-align: center; margin-bottom: 20px">
            <img
              :src="deductForm.avatar"
              style="width: 70px; height: 70px; border-radius: 6px"
            />
            <div style="margin-top: 8px; font-size: 16px; font-weight: bold">
              {{ deductForm.nickname }}
            </div>
            <div style="color: #999; margin-top: 4px">
              用户编号：{{ deductForm.user_no }}
            </div>
          </div>
          <el-form :model="deductForm" label-width="80px" size="medium">
            <el-form-item label="类型">
              <el-select v-model="deductForm.type" size="medium">
                <el-option
                  v-for="item in deductTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数量"
              ><el-input
                v-model.number="deductForm.num"
                type="number"
                size="medium"
                placeholder="数量"
            /></el-form-item>
            <el-form-item label="优惠券" v-if="deductForm.type == 11">
              <el-select v-model="deductForm.coupon_id" size="medium" clearable>
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              gap: 10px;
              display: flex;
              justify-content: flex-end;
            "
          >
            <el-button size="medium" @click="deductDialogVisibleMobile = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :loading="submitLoading"
              @click="submitDeductMobile"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "UserTable",
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      pageInfo: { total: 0 },
      levelList: [],
      statusList: [],
      rechargeTypeAll: [],
      rechargeTypeList: [],
      deductTypeList: [],
      couponList: [],
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        mobile: "",
        nickname: "",
        status: "",
        user_no: "",
        level_id: "",
        is_anchor: "",
      },
      columnOptions: [
        { label: "用户ID", prop: "id" },
        { label: "用户编号", prop: "user_no" },
        { label: "用户头像", prop: "avatar" },
        { label: "昵称", prop: "nickname" },
        { label: "手机号", prop: "mobile" },
        { label: "真实姓名", prop: "real_name" },
        { label: "会员等级", prop: "level_name" },
        { label: "父级ID", prop: "parent_id" },
        { label: "是否主播", prop: "is_anchor" },
        { label: "金币余额", prop: "balance" },
        { label: "钻石", prop: "point" },
        { label: "能量", prop: "energy" },
        { label: "总流水", prop: "total_pay" },
        { label: "总充值", prop: "total_recharge" },
        { label: "账号状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "user_no",
        "avatar",
        "nickname",
        "mobile",
        "real_name",
        "level_name",
        "parent_id",
        "is_anchor",
        "balance",
        "point",
        "energy",
        "total_pay",
        "total_recharge",
        "status",
        "created_at",
        "action",
      ],

      // ====== PC 弹窗 ======
      detailVisible: false,
      editDialogVisible: false,
      imageDialogVisible: false,
      rechargeDialogVisible: false,
      deductDialogVisible: false,

      // ====== 移动端 独立弹窗 ======
      detailVisibleMobile: false,
      editDialogVisibleMobile: false,
      imageDialogVisibleMobile: false,
      rechargeDialogVisibleMobile: false,
      deductDialogVisibleMobile: false,

      detailForm: {},
      editForm: {
        id: "",
        user_no: "",
        nickname: "",
        avatar: "",
        status: "",
        is_anchor: "",
      },
      imgLoading: false,
      imageList: [],
      imgPage: { page: 1, page_size: 12, type: "" },
      imgTotal: 0,
      rechargeForm: { user_id: "", type: "", num: "", coupon_id: "" },
      deductForm: { user_id: "", type: "", num: "", coupon_id: "" },

      // 新增：搜索栏折叠状态（默认折叠）
      searchCollapsed: true,
    };
  },
  created() {
    this.getUserList();
  },
  methods: {
    async getUserList() {
      this.loading = true;
      try {
        const res = await api.users.index({ params: this.searchParams });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.pageInfo.total = res.data.data.total;
          this.levelList = res.data.data.level;
          this.statusList = res.data.data.status;
          this.rechargeTypeAll = res.data.data.recharge_type || [];
          this.rechargeTypeList = this.rechargeTypeAll.filter(
            (t) => t.mode == 1
          );
          this.deductTypeList = this.rechargeTypeAll.filter((t) => t.mode == 2);
          this.getCouponList();
        }
      } finally {
        this.loading = false;
      }
    },
    async getCouponList() {
      const res = await api.coupon.index({
        params: { page: 1, page_size: 999 },
      });
      if (res.data.code == 1000) this.couponList = res.data.data.data || [];
    },

    // ============================================== PC 方法 ==============================================
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        user_no: row.user_no,
        nickname: row.nickname,
        avatar: row.avatar,
        status: row.status,
        is_anchor: row.is_anchor,
      };
      this.editDialogVisible = true;
    },
    async submitEdit() {
      if (!this.editForm.nickname) return this.$message.warning("请输入昵称");
      this.submitLoading = true;
      try {
        await api.users.updateUserInfo({
          user_id: this.editForm.id,
          nickname: this.editForm.nickname,
          avatar: this.editForm.avatar,
          status: this.editForm.status,
          is_anchor: this.editForm.is_anchor,
        });
        this.editDialogVisible = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },
    openImageLibrary() {
      this.imageDialogVisible = true;
      this.imgPage.page = 1;
      this.getImageList();
    },
    async getImageList(page = 1) {
      this.imgLoading = true;
      this.imgPage.page = page;
      try {
        const res = await api.images.index({ params: this.imgPage });
        if (res.data.code == 1000) {
          this.imageList = res.data.data.data || [];
          this.imgTotal = res.data.data.total || 0;
        }
      } finally {
        this.imgLoading = false;
      }
    },
    selectImage(img) {
      this.editForm.avatar = img.url;
      this.imageDialogVisible = false;
      this.$message.success("选择成功");
    },
    openRechargeDialog(row) {
      // 把row里头像、昵称、编号一并赋值
      this.rechargeForm = {
        user_id: row.id,
        type: "",
        num: "",
        coupon_id: "",
        avatar: row.avatar,
        nickname: row.nickname,
        user_no: row.user_no,
      };
      this.rechargeDialogVisible = true;
    },
    openDeductDialog(row) {
      this.deductForm = {
        user_id: row.id,
        type: "",
        num: "",
        coupon_id: "",
        avatar: row.avatar,
        nickname: row.nickname,
        user_no: row.user_no,
      };
      this.deductDialogVisible = true;
    },
    onRechargeTypeChange() {
      if (this.rechargeForm.type != 7) this.rechargeForm.coupon_id = "";
    },
    onDeductTypeChange() {
      if (this.deductForm.type != 11) this.deductForm.coupon_id = "";
    },
    async submitRecharge() {
      if (!this.rechargeForm.type || !this.rechargeForm.num)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.users.userRecharge({
          user_id: this.rechargeForm.user_id,
          type: this.rechargeForm.type,
          num: this.rechargeForm.num,
          coupon_id: this.rechargeForm.coupon_id || "",
        });
        this.rechargeDialogVisible = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },
    async submitDeduct() {
      if (!this.deductForm.type || !this.deductForm.num)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.users.userDeduct({
          user_id: this.deductForm.user_id,
          type: this.deductForm.type,
          num: this.deductForm.num,
          coupon_id: this.deductForm.coupon_id || "",
        });
        this.deductDialogVisible = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        mobile: "",
        nickname: "",
        status: "",
        user_no: "",
        level_id: "",
        is_anchor: "",
      };
      this.getUserList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getUserList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // ============================================== 移动端 独立方法 ==============================================
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },
    openEditDialogMobile(row) {
      this.editForm = { ...row };
      this.editDialogVisibleMobile = true;
    },
    async submitEditMobile() {
      if (!this.editForm.nickname) return this.$message.warning("请输入昵称");
      this.submitLoading = true;
      try {
        await api.users.updateUserInfo({
          user_id: this.editForm.id,
          nickname: this.editForm.nickname,
          avatar: this.editForm.avatar,
          status: this.editForm.status,
          is_anchor: this.editForm.is_anchor,
        });
        this.editDialogVisibleMobile = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },
    openImageLibraryMobile() {
      this.imageDialogVisibleMobile = true;
      this.imgPage.page = 1;
      this.getImageListMobile();
    },
    async getImageListMobile() {
      this.imgLoading = true;
      try {
        const res = await api.images.index({ params: this.imgPage });
        if (res.data.code == 1000) {
          this.imageList = res.data.data.data || [];
        }
      } finally {
        this.imgLoading = false;
      }
    },
    selectImageMobile(img) {
      this.editForm.avatar = img.url;
      this.imageDialogVisibleMobile = false;
      this.$message.success("更换成功");
    },
    openRechargeDialogMobile(row) {
      this.rechargeForm = {
        user_id: row.id,
        type: "",
        num: "",
        coupon_id: "",
        avatar: row.avatar,
        nickname: row.nickname,
        user_no: row.user_no,
      };
      this.rechargeDialogVisibleMobile = true;
    },
    openDeductDialogMobile(row) {
      this.deductForm = {
        user_id: row.id,
        type: "",
        num: "",
        coupon_id: "",
        avatar: row.avatar,
        nickname: row.nickname,
        user_no: row.user_no,
      };
      this.deductDialogVisibleMobile = true;
    },
    async submitRechargeMobile() {
      if (!this.rechargeForm.type || !this.rechargeForm.num)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.users.userRecharge({
          user_id: this.rechargeForm.user_id,
          type: this.rechargeForm.type,
          num: this.rechargeForm.num,
          coupon_id: this.rechargeForm.coupon_id || "",
        });
        this.rechargeDialogVisibleMobile = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },
    async submitDeductMobile() {
      if (!this.deductForm.type || !this.deductForm.num)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.users.userDeduct({
          user_id: this.deductForm.user_id,
          type: this.deductForm.type,
          num: this.deductForm.num,
          coupon_id: this.deductForm.coupon_id || "",
        });
        this.deductDialogVisibleMobile = false;
        this.getUserList();
      } finally {
        this.submitLoading = false;
      }
    },

    // 新增：切换搜索栏折叠状态
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
/* ====================== PC 样式 ====================== */
.user-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.color-green {
  color: #67c23a;
}
.color-red {
  color: #f56c6c;
}
.color-gray {
  color: #909399;
}
.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}
.img-item {
  width: 80px;
  height: 80px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
}
.img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-item:hover {
  border-color: #409eff;
}

/* ====================== 移动端样式 ====================== */
.mobile-user-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.nickname {
  font-size: 16px;
  font-weight: 500;
}
.uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.ok {
  background: #e6f7ee;
  color: #67c23a;
}
.status.ban {
  background: #fef0f0;
  color: #f56c6c;
}
.status.del {
  background: #f5f7fa;
  color: #909399;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style>

<style>
/* 自动适配 */
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
  .mobile-dialog {
    border-radius: 12px !important;
  }
  .mobile-dialog .el-dialog__body {
    padding: 15px !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue